export const separatorBaseClasses = 'shrink-0 bg-border';

export const separatorOrientationClasses = {
  horizontal: 'h-px w-full',
  vertical: 'h-full w-px',
} as const;
